import React from 'react'

function CampaignInformationStep({ formData, setFormData }) {
    return (
        <div className="animate-fade-in">
            <h3 className="fw-bold text-gray-900 mb-2">Campaign Information</h3>
            <p className="text-muted mb-8">This information is for internal use and to identify the campaign.</p>
            
            <div className="mb-6">
                <label className="form-label fw-semibold">Campaign Name</label>
                <input 
                    type="text" 
                    className="form-control form-control-lg" 
                    placeholder="Enter campaign name"
                    value={formData.campaignName}
                    onChange={(e) => setFormData({...formData, campaignName: e.target.value})}
                />
            </div>
            
            <div className="mb-6">
                <label className="form-label fw-semibold">Short Description</label>
                <textarea 
                    className="form-control form-control-lg" 
                    rows="3"
                    placeholder="Enter a brief description"
                    value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                ></textarea>
            </div>
        </div>
    )
}

export default CampaignInformationStep
